import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PriceSummaryDialogData {
    quoteId: string;
    totalGross: number;
    totalDiscount: number;
    totalPrice: number;
    netPrice: number;
    voucherCode: string;
    voucherValue: number;
    currency: string;
}

@Component({
    selector: 'app-price-summary-dialog',
    templateUrl: './price-summary-dialog.component.html',
    styleUrls: ['./price-summary-dialog.component.scss'],
    standalone: false
})
export class PriceSummaryDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: PriceSummaryDialogData) {}
}
